import { render, staticRenderFns } from "./UserActions.vue?vue&type=template&id=2a888686&scoped=true&"
import script from "./UserActions.vue?vue&type=script&lang=js&"
export * from "./UserActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a888686",
  null
  
)

export default component.exports